<template>
  <div>
    <div class="text-center display-1 font-weight-normal mb-6">
      Por favor, envie os arquivos que compo&ecirc;m ao INDGER
    </div>
    <v-row id="importacao-encoding" class="mx-auto">
      <v-col cols="12">
        <select-encoding
          id="fs-encoding-importacao-indger"
          label="Codificação dos arquivos"
          type="outlined"
          @encoding:selected="encodingSelected"
        />
      </v-col>
    </v-row>
    <!-- TODO remover após jun/2026 -->
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-alert dense outlined type="warning" class="mb-4 py-1 px-2">
          <div>
            <b>Atenção:</b> a partir da competência <b>06/2026</b> o arquivo de
            Serviços passa a exigir a coluna <b>SERV_016</b> (serviços
            cancelados). Use o modelo atualizado ao importar competências a
            partir de junho/2026.
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row id="importacao-upload-files" class="">
      <v-col cols="12" class="container-upload">
        <upload-files
          id="fs-upload-importacao-indger"
          :allowedFiles="allowedFiles"
          @file:uploaded="handleFileUploaded"
        >
          <template v-slot:upload-alert-extra-information>
            <br />
            <div v-if="entidadesObrigatorias.length">
              Obrigatórios:
              <span>{{ entidadesObrigatorias.join(", ") }}</span>
            </div>
            <div v-if="entidadesOpcionais.length">
              Opcionais:
              <span>{{ entidadesOpcionais.join(", ") }}</span>
            </div>
          </template>
        </upload-files>
      </v-col>
    </v-row>
    <v-row id="importacao-uploaded-files-table" class="mx-auto">
      <v-col cols="12">
        <tabela-mapeamento-arquivos
          :arquivos="uploadedFiles"
          :extensoes-permitidas="allowedFiles"
          @mapeamento:atualizado="handleMapeamentoAtualizado"
          @mapeamento:apagar-arquivo="handleMapeamentoArquivoApagado"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ImportacoesIndgerService from "@/services/ImportacoesIndgerService";

  export default {
    name: "ImportacoesIndgerSecondTabContent",
    components: {
      SelectEncoding: () => import("@/components/general/SelectEncoding.vue"),
      UploadFiles: () => import("@/components/general/UploadFiles/Index.vue"),
      TabelaMapeamentoArquivos: () =>
        import(
          "@/components/administracao/importacoes-indger/TabelaMapeamentoArquivos.vue"
        ),
    },
    data() {
      return {
        encoding: "UTF-8",
        allowedFiles: [],
        uploadedFiles: [],
        entidades: [],
        entidadesObrigatorias: [],
      };
    },
    computed: {
      entidadesOpcionais() {
        return this.entidades.filter(
          (entidade) => !this.entidadesObrigatorias.includes(entidade),
        );
      },
    },
    watch: {
      encoding() {
        this.emitEventImportUpdated();
      },
    },
    mounted() {
      this.getExtensoesPermitidas();
      this.getEntidadesIndger();
      this.getEntidadesObrigatoriasIndger();
    },
    methods: {
      emitEventImportUpdated() {
        this.$emit("import:updated", {
          encoding: this.encoding,
        });
      },
      encodingSelected(event) {
        this.encoding = event;
      },
      getExtensoesPermitidas() {
        ImportacoesIndgerService.getExtensoesPermitidas()
          .then((response) => (this.allowedFiles = response))
          .catch((error) => console.error(error));
      },
      getEntidadesIndger() {
        ImportacoesIndgerService.getEntidadesIndger()
          .then((response) => (this.entidades = response))
          .catch((error) => console.error(error));
      },
      getEntidadesObrigatoriasIndger() {
        ImportacoesIndgerService.getEntidadesObrigatoriasIndger()
          .then((response) => (this.entidadesObrigatorias = response))
          .catch((error) => console.error(error));
      },
      handleFileUploaded(event) {
        const { files } = event;
        files.forEach((file) => this.uploadedFiles.push(file));
      },
      handleMapeamentoAtualizado(event) {
        this.$emit("mapeamento:atualizado", event);
      },
      handleMapeamentoArquivoApagado(event) {
        this.uploadedFiles = this.uploadedFiles.filter(
          (item) => item.id !== event.id,
        );
        this.$emit("mapeamento:apagar-arquivo", event);
      },
    },
  };
</script>

<style>
  .container-upload {
    padding-top: 0;
  }
</style>
